import { getLayoutProps } from '@/utils/layout/layout';
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import User from '@/store/user';
import UserLists from '@/components/UserLists/UserLists';
import PageLayout from '@/components/PageLayout';

export default function Lists({ responsiveLogo, favouritesImage, suggestedImage }) {
  const [user, setUser] = useState();
  const router = useRouter();

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      <UserLists user={user} favouritesImage={favouritesImage} suggestedImage={suggestedImage} />
    </>
  );
}

Lists.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'lists'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 2 } }, locale);
  const favouritesImage = layoutProps?.emptyStates?.favourite_products_empty_states?.url
    ? layoutProps?.emptyStates?.favourite_products_empty_states?.url
    : null;
  const suggestedImage = layoutProps?.emptyStates?.smart_lists_empty_state?.url
    ? layoutProps?.emptyStates?.smart_lists_empty_state?.url
    : null;
  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_lists: (await import(`../../../../prebuild-data/i18n/${locale}/user_lists.json`)).default,
    user_history: (await import(`../../../../prebuild-data/i18n/${locale}/user_history.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      favouritesImage,
      suggestedImage,
      messages,
    },
  };
}
